import notify from 'devextreme/ui/notify';
import { NotifyUser, NotifyType } from './types';

const notificationMarginPx = 20;

export const notifyUser: NotifyUser = ({
  msg,
  type = NotifyType.INFO,
  time = 3800,
  width = 'auto',
  onInit
}) => {
  const options = {
    message: msg,
    width,
    maxWidth: `calc(100% - ${notificationMarginPx * 2}px)`,
    position: {
      at: 'left bottom',
      my: 'left bottom',
      offset: `${notificationMarginPx} -${notificationMarginPx}`
    },
    onInitialized: onInit ? (e: unknown) => onInit(e) : undefined
  };

  notify(options, type, time);
};
